import React from 'react';

export default function CarRentalById(props) {
  return (
    <div className='App-paper'>
    CarrentalById
    </div>
  )
};